import { observer } from 'mobx-react-lite'
import React from 'react'
import SettingCard from '../UserAccountMenu/SettingCard'
import { storeElement } from 'GlobalStores/Cores/Elements/StoreElement'
import SubscriptionsRoute from './Route'
import { Stack, styled } from '@mui/material'
import Breadcrumb from '../UserAccountMenu/Breadcrumb'
import MobileLayoutWrapper from '../UserAccountMenu/MobileLayoutWrapper'
import { useSizeWindow } from 'Helpers/GlobalHelpers'

const SubscriptionsWrapper = observer(props => {

    const { width } = useSizeWindow()

    return (
        <>
            {width > 834 ? (
                <SettingCard
                    title={storeElement.settingCard.title || ''}
                    titleAlign={storeElement.settingCard.titleAlign || 'left'}
                    padding={storeElement.settingCard.padding || '50px 40px 20px 40px'}
                    display="block">
                    <SubscriptionsRoute />
                </SettingCard>
            ) : (
                <MobileLayoutWrapper>
                    <Stack width="100%">
                        <Breadcrumb />
                        <SettingCard title={storeElement.settingCard.title || ''} titleAlign={storeElement.settingCard.titleAlign || 'center'} display="block">
                            <SubscriptionsRoute />
                        </SettingCard>
                    </Stack>
                </MobileLayoutWrapper>
            )}
        </>
    )
})

const StackMobileLayout = styled(Stack)`
    align-items: center;
    background: #d1d9e2 !important;
`

export default SubscriptionsWrapper
